import React, {useEffect, useState} from 'react';
import { Styles } from '../../../config/design/styles';
import { withStyles } from "@mui/styles";
import { connect } from "trim-redux";
import {useNavigate,Link} from "react-router-dom";
import axios from "axios";
import {defaultVariables} from "../../../config";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@mui/material/Grid2";
import AdminDashSkeleton from "../../components/loaders/AdminDashSkeleton";
import {useTranslation} from "react-i18next";
import {Box, IconButton, Typography} from "@mui/material";
import {
    BadgeCheck,
    BadgeInfo,
    CircleArrowRight,
    CookingPot,
    CreditCard,
    Eye,
    MessageCircle,
    MoveRight, SendHorizontal,
    Store
} from "lucide-react";
import {currencySymbol, price} from "../../../config/values";
import {LineChart} from "@mui/x-charts/LineChart";
import moment from "moment/moment";
import CategorySliderItem from "../front/categories/components/CategorySliderItem";
import SwiperSlider from "../../components/elements/slider/SwiperSlider";
import ProductCard from "../supplier/products/components/ProductCard";
import SubTitle from "../../components/elements/SubTitle";
import SupplierDashSkeleton from "../../components/loaders/SupplierDashSkeleton";

const SupplierDashboard = ({ classes,user }) => {
    const { t } = useTranslation();
    const [loading,setLoading] = useState(true);
    const [data,setData] = useState(null);
    const [loadError,setLoadError] = useState(false);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/dashboards/get-supplier`,config)
            .then(response => {
                setData(response.data);
                setLoadError(false);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setData(null);
                setLoadError(true);
                setLoading(false);
            });
    }
    useEffect(() => {
        // Fetch match data when component mounts
        loadData();
    }, []);
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('dashboard')}>
            <Grid container spacing={2} justify="center" className="dashboard">
                {
                    loading ?
                        <SupplierDashSkeleton/>
                        :
                    loadError || !data ?
                        <Grid item size={12}>
                            <Box className="bg-gray-box p-15">
                                <Typography>{t('dashboard_load_error', { defaultValue: 'Dashboard verileri yüklenemedi. Lütfen sayfayı yenileyin.' })}</Typography>
                            </Box>
                        </Grid>
                        :
                        <>
                            {data.shop_missing && (
                                <Grid item size={12}>
                                    <Box className="bg-gray-box p-15 mb-10">
                                        <Typography>{t('shop_setup_required', { defaultValue: 'Mağaza bilgilerinizi tamamladıktan sonra istatistikler burada görünecek.' })}</Typography>
                                    </Box>
                                </Grid>
                            )}
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box  bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/vendor/orders'>
                                    <BadgeInfo className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item"> {t('pending_orders')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_orders}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box  bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/vendor/orders'>
                                    <CookingPot className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item"> {t('preparing_orders')}</span>
                                    <strong style={{fontSize:20}}>{data.preparing_orders}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/vendor/orders'>
                                    <SendHorizontal className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item"> {t('on_way_orders')}</span>
                                    <strong style={{fontSize:20}}>{data.on_way_orders}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/vendor/orders'>
                                    <BadgeCheck className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item"> {t('finished_orders')}</span>
                                    <strong style={{fontSize:20}}>{data.finished_orders}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,sm:6,md:6}}>
                                <Box className="bg-gray-box">
                                    <div className="flex-space">
                                        <strong>{t('orders')}</strong>
                                        <IconButton
                                            size="small"
                                            variant="outlined"
                                            component={Link}
                                            to='/panel/vendor/orders'
                                        >
                                            <CircleArrowRight className="lucide-icon-gray"/>
                                        </IconButton>
                                    </div>
                                    <hr className="mb-15 mt-5"/>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('today')}</Typography>
                                        <strong>{data.today_orders}</strong>
                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('yesterday')}</Typography>
                                        <strong>{data.yesterday_orders}</strong>
                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('this_month')}</Typography>
                                        <strong>{data.this_month_orders}</strong>
                                    </div>

                                    <div className="flex-space mb-10">
                                        <strong className="secondary">{t('total')}</strong>
                                        <strong className="secondary">{data.total_orders}</strong>
                                    </div>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,sm:6,md:6}}>
                                <Box className="bg-gray-box">
                                    <div className="flex-space">
                                        <strong>{t('netSales')}</strong>
                                        <IconButton
                                            size="small"
                                            variant="outlined"
                                            component={Link}
                                            to='/panel/vendor/orders'
                                        >
                                            <CircleArrowRight className="lucide-icon-gray"/>
                                        </IconButton>
                                    </div>
                                    <hr className="mb-15 mt-5"/>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('today')}</Typography>
                                        <strong>{price(data.today_sales)} {currencySymbol}</strong>

                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('yesterday')}</Typography>
                                        <strong>{price(data.yesterday_sales)} {currencySymbol}</strong>

                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('this_month')}</Typography>
                                        <strong>{price(data.this_month_sales)} {currencySymbol}</strong>

                                    </div>

                                    <div className="flex-space mb-10">
                                        <strong className="secondary">{t('total')}</strong>
                                        <strong className="secondary">{price(data.total_sales)} {currencySymbol}</strong>

                                    </div>
                                </Box>
                            </Grid>
                            <Grid item size={12}>
                                <LineChart
                                    dataset={(data.chart_orders || []).map(item => ({
                                        x: moment(item.x).format("MMM D"),
                                        y: item.y
                                    }))}
                                    xAxis={[{ dataKey: "x", scaleType: "band", label: "Days" }]}
                                    yAxis={[{
                                        // Add this yAxis configuration
                                        valueFormatter: (value) => Math.floor(value).toString(), // Rounds down and converts to string
                                        tickMinStep: 1 // Ensures ticks only show whole numbers
                                    }]}
                                    series={[{ dataKey: "y", label: "Orders", color: '#F0051F' }]}
                                    height={300}
                                    margin={{ left: 30, right: 30, top: 30, bottom: 50 }}
                                    grid={{ vertical: true, horizontal: true }}
                                />
                            </Grid>
                            <Grid item size={12} className="my-10">
                                <SubTitle className="dialog-title" align="left">{t('mostSellingProducts')}</SubTitle>
                            </Grid>
                            <Grid item size={12}>
                                <Grid container spacing={2}>
                                    {
                                        (data.most_selling_products || []).map((item,index) => (
                                            <Grid item size={{xs:6,sm:4,md:4,lg:2}} key={index}>
                                                <ProductCard supplier_dashboard dashboard item={item} reload={() => loadData()}/>
                                            </Grid>
                                        ))
                                    }
                                </Grid>

                            </Grid>

                        </>


                }
            </Grid>
        </AppAnimate>

    );
};

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mstp)(SupplierDashboard));
